<template>
  <div>
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{alerta.mensaje}}
    </v-alert>

    <el-listado
      v-if="listado.mostrar"
      v-bind="listado"
      v-bind:permiso="permiso"
      v-bind:modelo-api="modeloApi"
      v-on:editarItem="editar"
      v-on:crearItem="crear"
      v-on:verItem="ver"
      v-on:mostrarError="mostrarError"
    ></el-listado>

    <v-dialog
      v-model="formulario.mostrar"
      persistent
      transition="dialog-bottom-transition"
      max-width="600px"
    >
      <el-formulario
        v-if="formulario.mostrar"
        v-bind="formulario"
        v-bind:permiso="permiso"
        v-bind:modelo-api="modeloApi"
        v-on:alGuardar="alGuardar"
        v-on:alCerrar="alCerrar"
      ></el-formulario>
    </v-dialog>
  </div>
</template>

<script>
import mixinAbm from '@/mixins/abm'
import ElListado from './TipoEntidadesAbmListado'
import ElFormulario from './TipoEntidadesAbmFormulario'
import Modelo from '@/api/tipoEntidad'
import _ from 'lodash'

export default {
  mixins: [mixinAbm],
  components: {
    ElListado,
    ElFormulario
  },
  data () {
    return {
      permiso: 'admin_tipo-entidades',
      modeloApi: Modelo
    }
  },
  methods: {
    crear () {
      this.formulario = _.assign(this.formulario, {
        operacion: 'alta',
        titulo: 'Crear',
        item: {
          id: 0,
          nombre: null,
          padre_id: null
        },
        mostrar: true
      })
    },
    ejecutarAlGuardar (item) {
      if (this.$store.getters.tengoRolNombre('Superadmin')) {
        this.$store.dispatch('usuario')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
